import React from 'react';
import userPicture from '@/assets/images/user-picture.png';

interface HeroSectionProps {
  title?: string;
  description: string;
  actions?: React.ReactNode;
  showProfilePicture?: boolean;
  /** CMS avatar URL; the bundled picture stays as the offline/default fallback. */
  avatarUrl?: string;
  avatarAlt?: string;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  description,
  actions,
  showProfilePicture = false,
  avatarUrl,
  avatarAlt,
}) => {
  return (
    <section className="mb-16">
      <div className="max-w-4xl">
        {showProfilePicture && (
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <img
                src={avatarUrl ?? userPicture}
                alt={avatarAlt ?? ''}
                fetchPriority="high"
                className="h-44 w-44 rounded-full object-cover ring-1 ring-border"
              />
            </div>
          </div>
        )}
        {title && (
          <h2 className="mb-6 text-3xl leading-snug font-semibold tracking-tight text-foreground">
            {title}
          </h2>
        )}
        <p className="mb-8 text-lg leading-relaxed text-muted-foreground">
          {description}
        </p>
        {actions && <div className="flex flex-wrap gap-4">{actions}</div>}
      </div>
    </section>
  );
};
